
import { defineComponent, computed, PropType } from 'vue';
import { useI18n } from 'vue-i18n';
import Skeleton from 'primevue/skeleton';
import useProductOverrides from '@/composables/segmentations/useProductOverrides';

interface Override {
  id_custom_data_definition: number;
  custom_field_name: string;
  system_field_name: string;
  priority: number;
  schemaName?: string;
}

export default defineComponent({
  name: 'OverrideInfoPanel',

  components: {
    Skeleton,
  },

  props: {
    systemFieldName: {
      type: String,
      required: true,
    },
  },

  setup(props) {
    const { t } = useI18n();
    const { getOverridesForField, isLoading, hasError } = useProductOverrides();

    const overrides = computed(() => getOverridesForField(props.systemFieldName));
    const loading = computed(() => isLoading.value);
    const error = computed(() => hasError.value);

    return {
      t,
      overrides,
      loading,
      error,
    };
  },
});
